<template>
  <div class="content profile">
    <div class="container-fluid">
      <card>
        <template slot="header">
          <header-navigator :routes="routesData.data"></header-navigator>
        </template>
        <template>
          <form>
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-4">
                    <fg-input type="text"
                              label="First Name"
                              placeholder="First Name"
                              v-model="first_name">
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input type="text"
                              label="Last Name"
                              placeholder="Last Name"
                              v-model="last_name">
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input type="email"
                              label="Email"
                              placeholder="Email"
                              v-model="email">
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <fg-input type="text"
                              label="Company Name"
                              placeholder="Company"
                              v-model="company_name">
                    </fg-input>
                  </div>
                  <div class="col-md-8">
                    <fg-input 
                      type="text"
                      label="Website URL"
                      placeholder="URL"
                      v-model="website_url"
                      v-if="showWebsiteInput">
                    </fg-input>
                    <fg-input 
                      type="text"
                      label="Address"
                      placeholder="Address"
                      v-model="address"
                      v-if="showAddressInput">
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8">
                    <fg-textarea
                      :rows=2
                      label="Company Description"
                      placeholder="Description"
                      :maxLength=100
                      v-model="company_description">
                    </fg-textarea>
                  </div>
                  <div class="col-md-4">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="container d-flex justify-content-center">
                <small-button :buttonText="save_text" :processing-click="attempting_save" v-on:onButtonClicked="saveChanges" />
                <discard-button :buttonText="discard_text"  v-on:onButtonClicked="discardChanges"/>
              </div>
            </div>
          </form>
        </template>
      </card>
      <card>
        <template slot="header">
          <div class="row">
            <div class="col">
              <div class="header-navigator">
                <div class="header-navigator-title current-route">
                  Reset Password
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="errors" v-if="password_errors.length">
                <div class="errors-title">Whoops!</div>
                <ul>
                  <li class="error" v-for="error in password_errors" v-bind:key="error">{{ error }}</li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template>
          <form>
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-4">
                    <fg-input type="password"
                              label="Current Password"
                              placeholder=""
                              v-model="current_password">
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input type="password"
                              label="New Password"
                              placeholder=""
                              caption="Must be at least 6 characters."
                              v-model="new_password">
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input type="password"
                              label="Confirm New Password"
                              placeholder=""
                              v-model="confirm_new_password">
                    </fg-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="container d-flex justify-content-center">
                <small-button :buttonText="save_text" :processing-click="attempting_password_save" v-on:onButtonClicked="savePasswordChanges" />
                <discard-button :buttonText="discard_text"  v-on:onButtonClicked="discardPasswordChanges"/>
              </div>
            </div>
          </form>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import HeaderNavigator from '@/components/UIComponents/HeaderNavigator.vue'
  import SmallButton from '@/components/UIComponents/Buttons/SmallButton.vue'
  import DiscardButton from '@/components/UIComponents/Buttons/DiscardButton.vue'

  export default {
    components: {
      Card,
      HeaderNavigator,
      SmallButton,
      DiscardButton,
    },
    data () {
      return {
        first_name: '',
        last_name: '',
        email: '',
        company_name: '',
        company_description: '',
        website_url: '',
        address: '',
        routesData: {
          data: [
            {title: 'Profile', route: '/profile'},
          ]
        },
        save_text: 'SAVE',
        discard_text: 'DISCARD',
        attempting_save: false,
        password_errors: [],
        current_password: '',
        new_password: '',
        confirm_new_password: '',
        attempting_password_save: false,
      }
    },
    methods: {
      async saveChanges () {
        var payload = {
          merchant_id: this.$store.getters.advertiser.id,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          company_name: this.company_name,
          company_description: this.company_description,
          website_url: this.website_url,
          address: this.address,
        }
      
        this.attempting_save = true;
        await this.$store.dispatch('uploadAdvertiserUpdates', payload);
        this.attempting_save = false;

        this.saveUserChanges();
        this.saveCompanyChanges();
        this.goToAnalytics();
      },
      async savePasswordChanges () {
        if (!this.attempting_password_save) {
          this.checkForPasswordErrors();
          if (!this.password_errors.length) {
            const headers = {
              headers: {
                Authorization: `JWT ${this.$store.state.jwt.jwt}`,
                'Content-Type': 'application/json',
              }
            }

            var payload = JSON.stringify({
              password: this.current_password,
              new_password: this.new_password,
            })

            const self = this;
            this.attempting_password_save = true;
            axios.put(this.$store.state.user.endpoints.updateUserPassword, payload, headers)
              .then((response)=>{
                this.$store.dispatch('setModalTitle', { title: 'Password Reset!' })
                this.$store.dispatch('setSVGType', { svg_type: 'checkmark' })
                this.$store.dispatch('setModalMessage', { message: 'refreshing...' })
                this.$store.dispatch('setModalVisible', { visible: true })
                this.attempting_password_save = false;
                setTimeout(function () {
                  self.discardPasswordChanges();
                  self.$store.dispatch('setModalVisible', { visible: false })
                  self.$nextTick(() => {
                    self.$emit('scrollTop', 0)
                  });
                }, 2000)
              })
              .catch((error)=>{
                this.password_errors.push("Current password is incorrect.");
                this.attempting_password_save = false;
              });
          }
        }
      },
      saveUserChanges() {
        const payload = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
        }

        this.$store.dispatch('updateUser', payload)
      },
      saveCompanyChanges() {
        const payload = {
          company_name: this.company_name,
          company_description: this.company_description,
          website_url: this.website_url,
          address: this.address
        }

        this.$store.dispatch('updateAdvertiser', payload)
      },
      discardChanges () {
        this.$store.dispatch('setModalTitle', { title: 'Changes Discarded!' })
        this.$store.dispatch('setSVGType', { svg_type: 'trash' })
        this.$store.dispatch('setModalMessage', { message: 'redirecting...' })
        this.$store.dispatch('setModalVisible', { visible: true })
        const self = this;
        setTimeout(function () { 
            self.$router.push('/analytics'); 
            self.$store.dispatch('setModalVisible', { visible: false });
          }, 2000)
      },
      discardPasswordChanges() {
        this.current_password = '';
        this.new_password = '';
        this.confirm_new_password = '';
      },
      goToAnalytics() {
        this.$store.dispatch('setModalTitle', { title: 'Changes Saved!' })
        this.$store.dispatch('setSVGType', { svg_type: 'checkmark' })
        this.$store.dispatch('setModalMessage', { message: 'redirecting...' })
        this.$store.dispatch('setModalVisible', { visible: true })
        const self = this;
        setTimeout(function () {
            self.$router.push('/analytics'); 
            self.$store.dispatch('setModalVisible', { visible: false })
          }, 2000)
      },
      checkForPasswordErrors() {
        this.password_errors = []

        if (this.new_password.length < 6) {
          this.password_errors.push("New password must be at least 6 characters");
        }

        if (this.new_password !== this.confirm_new_password) {
          this.password_errors.push("Passwords do not match");
        }
      },
    },
    computed: {
      showWebsiteInput () {
        return this.$store.getters.advertiser.company_type === "Online Retail Store";
      },
      showAddressInput () {
        return (this.$store.getters.advertiser.company_type === "Restaurant") || (this.$store.getters.advertiser.company_type === "Physical Retail Store");
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.$emit('scrollTop', 0)
      });
    
      let user = this.$store.getters.user
      this.first_name = user.first_name
      this.last_name = user.last_name
      this.email = user.email

      let advertiser = this.$store.getters.advertiser
      this.company_name = advertiser.name
      this.company_description = advertiser.description
      this.website_url = advertiser.website_url
      this.address = advertiser.address
    },
  }
</script>
